import { jsx as n, jsxs as H, Fragment as xt } from "react/jsx-runtime";
import { faSchoolFlag as Xt } from "@fortawesome/pro-regular-svg-icons/faSchoolFlag";
import { faSuitcase as Yt } from "@fortawesome/pro-regular-svg-icons/faSuitcase";
import { faUser as qt } from "@fortawesome/pro-solid-svg-icons/faUser";
import Ut from "@mui/material/Avatar";
import T from "classnames";
import { createTheme as Zt, ThemeProvider as Gt } from "@mui/material/styles";
import ut, { useState as mt, forwardRef as Jt, useRef as Qt } from "react";
import { faCaretDown as Kt } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { Tooltip as Vt, Popover as At, Box as Pt, Typography as te } from "@mui/material";
import { faArrowDownToLine as ee } from "@fortawesome/pro-regular-svg-icons/faArrowDownToLine";
import { faLoader as oe } from "@fortawesome/pro-regular-svg-icons/faLoader";
import { faLock as ne } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faPencil as re } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { faPlus as ae } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faTrashCan as ie } from "@fortawesome/pro-regular-svg-icons/faTrashCan";
import { faArrowRight as le } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faChevronDown as se } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronRight as ce } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { dayjsLocalizer as de, Calendar as fe } from "react-big-calendar";
import { faChevronLeft as Bt } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { FontAwesomeIcon as ue } from "@fortawesome/react-fontawesome";
import { faCircleMinus as me, faTriangleExclamation as ge, faHourglass as he, faCircleCheck as be } from "@fortawesome/pro-solid-svg-icons";
import { Link as Et } from "react-router-dom";
import { faCircleCheck as pe } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleInfo as ye } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { faHandWave as _e } from "@fortawesome/pro-regular-svg-icons/faHandWave";
import { faHourglassHalf as xe } from "@fortawesome/pro-regular-svg-icons/faHourglassHalf";
import { faLightbulbOn as ve } from "@fortawesome/pro-regular-svg-icons/faLightbulbOn";
import { faOctagonExclamation as we } from "@fortawesome/pro-regular-svg-icons/faOctagonExclamation";
import { faTriangleExclamation as Se } from "@fortawesome/pro-regular-svg-icons/faTriangleExclamation";
import { faXmark as Me } from "@fortawesome/pro-regular-svg-icons/faXmark";
import ke from "react-spinkit";
import $e from "@mui/material/Paper";
import { faLoader as Ce } from "@fortawesome/pro-solid-svg-icons/faLoader";
import De from "@mui/material/TextField";
import Le from "@mui/material/InputAdornment";
import { faEye as We } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash as Te } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import $t from "@mui/material/useMediaQuery";
import '../index.css';const St = {
  xxl: {
    width: 64,
    height: 64,
    icon: "2xl"
  },
  xl: {
    width: 56,
    height: 56,
    icon: "xl"
  },
  lg: {
    width: 48,
    height: 48,
    icon: "lg"
  },
  md: {
    width: 40,
    height: 40,
    /**
     * 'md' is not a valid size for FontAwesomeIcon.
     * When undefined is passed to FontAwesomeIcon as a size value,
     * the icon will default to the current font size of its parent element.
     */
    icon: void 0
  },
  sm: {
    width: 32,
    height: 32,
    icon: "sm"
  },
  xs: {
    width: 24,
    height: 24,
    icon: "xs"
  },
  xxs: {
    width: 16,
    height: 16,
    icon: "2xs"
  }
}, Fe = ({
  size: t = "md",
  children: r,
  fallback: o,
  alt: e
}) => {
  if (r)
    return r;
  switch (o) {
    case "person":
      return /* @__PURE__ */ n(W, { icon: qt, size: St[t].icon, alt: e });
    case "school":
      return /* @__PURE__ */ n(
        W,
        {
          icon: Xt,
          size: St[t].icon,
          alt: e
        }
      );
    case "employer":
      return /* @__PURE__ */ n(W, { icon: Yt, size: St[t].icon, alt: e });
    default:
      return null;
  }
}, xa = ({
  children: t = void 0,
  fallback: r = "person",
  size: o = "md",
  ...e
}) => /* @__PURE__ */ n(Ut, { sx: St[o], ...e, children: Fe({ size: o, fallback: r, children: t, alt: e.alt }) }), Be = "_badgeContainer_1wqb3_3", Oe = "_label_1wqb3_9", ze = "_large_1wqb3_18", Re = "_badge_1wqb3_3", He = "_number_1wqb3_29", ft = {
  badgeContainer: Be,
  label: Oe,
  large: ze,
  badge: Re,
  number: He
}, Ot = {}, Ne = (t) => t.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/(\d)([a-zA-Z])/g, "$1 $2").replace(/([a-zA-Z])(\d)/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(/\s+/g, "-"), Ae = (t) => t.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(
  /(?:\s+|^)(\w)/g,
  (r, o, e) => e === 0 ? o : o.toUpperCase()
).replace(/\s+/g, ""), ot = {
  black: "#000",
  blackV2: "#1e1a12",
  white: "#fff",
  font: "#363636",
  brandClever: "#4271f6",
  brandOneroster: "#0f4d87",
  blue: "#4397ea",
  blueBg: "#f5fbff",
  blueDark: "#2386e7",
  blueXtraDark: "#1477d8",
  blueContrastDark: "#124577",
  blueExtraLight: "#e6f3fa",
  blueLight: "#c4e1f2",
  blueMedium: "#68aaee",
  blueSteel: "#728dac",
  blueSteelDark: "#5f7ea0",
  blueSteelXtraDark: "#516d8f",
  blueSteelContrastDark: "#3a4e66",
  blueSteelExtraLight: "#e1e7ed",
  blueSteelLight: "#cbdaeb",
  blueSteelMedium: "#8da7c4",
  gray: "#999",
  grayBg: "#f6f6f6",
  grayDark: "#6f6f6f",
  grayDarkV2: "#71726e",
  grayXtraDark: "#595959",
  grayExtraLight: "#eee",
  grayLight: "#dbdbdb",
  grayMedium: "#bebdbd",
  green: "#5aa43d",
  greenBg: "#fbfff4",
  greenDark: "#429617",
  greenXtraDark: "#268900",
  greenContrastDark: "#1c6400",
  greenExtraLight: "#f1f6e6",
  greenLight: "#ddedc9",
  greenMedium: "#7db866",
  indigo: "#7180d6",
  indigoDark: "#5d6ed0",
  indigoXtraDark: "#5364c6",
  indigoContrastDark: "#394799",
  indigoExtraLight: "#e6e9f8",
  indigoLight: "#b7c3ff",
  indigoMedium: "#8c99e3",
  orange: "#ff8000",
  orangeDark: "#f07000",
  orangeXtraDark: "#d66000",
  orangeContrastDark: "#99430d",
  orangeExtraLight: "#feedd5",
  orangeLight: "#ffd9b8",
  orangeMedium: "#fc9b5f",
  purple: "#9974dc",
  purpleDark: "#8d64d8",
  purpleXtraDark: "#8861cf",
  purpleContrastDark: "#583cbd",
  purpleExtraLight: "#ede8f8",
  purpleLight: "#d9c4ff",
  purpleMedium: "#ae8fea",
  red: "#e46658",
  redDark: "#d85446",
  redXtraDark: "#d24536",
  redContrastDark: "#9e2518",
  redExtraLight: "#ffe9e9",
  redLight: "#ffb3ab",
  redMedium: "#f67c6f",
  teal: "#16a2a2",
  tealDark: "#149090",
  tealDarkV2: "#2b7383",
  tealXtraDark: "#128484",
  tealContrastDark: "#0a5656",
  tealExtraLight: "#e3f4f2",
  tealLight: "#cceaea",
  tealLightV2: "#ecf5f7",
  tealMedium: "#62bcbc",
  violet: "#c863d9",
  violetDark: "#c253d5",
  violetXtraDark: "#ba3dd0",
  violetContrastDark: "#752383",
  violetExtraLight: "#f5e9f7",
  violetLight: "#f6c8ff",
  violetMedium: "#d68ce3",
  pink: "#d85a8c",
  pinkDark: "#cc3e76",
  pinkXtraDark: "#ba2c65",
  pinkContrastDark: "#811d45",
  pinkExtraLight: "#ffebf3",
  pinkLight: "#ffcce0",
  pinkMedium: "#fbb1cf",
  yellow: "#fad961",
  yellowV2: "#f5ec1e",
  yellowDark: "#f5c614",
  yellowXtraDark: "#eebc04",
  yellowContrastDark: "#986f15",
  yellowContrastLight: "#ffffef",
  yellowExtraLight: "#fff7da",
  yellowLight: "#ffefb7",
  yellowLightV2: "#fbfbca",
  yellowMedium: "#fbdf78",
  yellowTextDark: "#b28d02"
}, Ee = {
  base: "'Halis Rounded', 'Segoe UI', 'HelveticaNeue-Light', 'Roboto', sans-serif",
  baseV2: "'GT Flexa', 'Segoe UI', 'HelveticaNeue-Light', 'Roboto', sans-serif",
  body: "'Roboto', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  code: "'Roboto Mono', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  signature: "'Sofia', cursive",
  emoji: "emoji"
}, Ie = {
  robotoLight: 300,
  robotoRegular: 400,
  robotoMedium: 500,
  robotoBold: 700,
  robotoBlack: 900,
  halisThin: 100,
  halisLight: 300,
  halisBook: 400,
  halisRegular: 500,
  halisMedium: 600,
  halisBold: 700,
  halisBlack: 800
}, je = {
  iconXxs: "10px",
  iconXs: "12px",
  iconXtSm: "14px",
  iconSm: "16px",
  iconMd: "20px",
  iconLg: "24px",
  iconXl: "32px",
  iconXxl: "40px",
  fontSizeTitleLg: "64px",
  fontSizeTitle: "26px",
  fontSizeTitleSm: "24px",
  fontSizeTitleXs: "22px",
  fontSizeLg: "20px",
  fontSizeMd: "18px",
  fontSizeSm: "16px",
  fontSizeXs: "14px",
  fontSizeXxs: "12px",
  fontSizeXxxs: "10px",
  fontSizeEmoji: "32px",
  appbarHeight: "64px",
  sidebarWidth: "64px",
  subnavHeight: "48px",
  containerBorderWidth: "2px",
  containerBorderRadiusLarge: "32px",
  containerBorderRadiusMedium: "16px",
  containerBorderRadius: "8px",
  containerBorderRadiusXtSmall: "6px",
  containerBorderRadiusSmall: "4px",
  containerBorderRadiusTop: "8px 8px 0 0",
  containerBorderRadiusBottom: "0 0 8px 8px",
  containerBorderRadiusLeft: "8px 0 0 8px",
  containerBorderRadiusRight: "0 8px 8px 0",
  containerBorderRadiusTopLeft: "8px 0 0 0",
  containerBorderRadiusTopRight: "0 8px 0 0",
  containerBorderRadiusBottomLeft: "0 0 0 8px",
  containerBorderRadiusBottomRight: "0 0 8px 0",
  contentHeight: "calc(100vh - 64px)",
  chatBorderRadiusTopLeft: "2px 16px 16px 16px",
  shadow: "0 2px 10px 0 rgba(0, 0, 0, 0.15)",
  shadowTop: "0 -2px 10px 0 rgba(0, 0, 0, 0.15)",
  shadowExtraLight: "0 1px 5px rgba(0, 0, 0, 0.12)",
  shadowLight: "0 0 5px 0 rgba(0, 0, 0, 0.15)",
  shadowMedium: "0 4px 12px rgba(0, 0, 0, 0.3)",
  shadowStrong: "0 2px 60px 0 rgba(0, 0, 0, 0.2)",
  shadowInset: "inset 0 0 5px 0 rgba(0, 0, 0, 0.1)",
  shadowBottom: "0px 10px 10px -6px rgba(0, 0, 0, 0.15)"
}, Xe = {
  tt: "1px",
  tiny: "2px",
  xxs: "4px",
  xs: "8px",
  xtSm: "10px",
  input: "10.5px",
  sm: "12px",
  md: "16px",
  xtMd: "24px",
  lg: "32px",
  xl: "40px",
  xxl: "48px"
}, Ye = {
  defaultGray: `2px solid ${ot.gray}`,
  defaultGrayLight: `1px solid ${ot.grayLight}`,
  defaultGrayMedium: `1px solid ${ot.grayMedium}`,
  defaultGrayExtraLight: `1px solid ${ot.grayExtraLight}`,
  defaultBlue: `1px solid ${ot.blue}`,
  defaultBlueDark: `2px solid ${ot.blueDark}`,
  defaultRed: `2px solid ${ot.red}`,
  focusBlue: `2px solid ${ot.blue}`,
  white: `1px solid ${ot.white}`
}, qe = {
  widthXs: "520px",
  widthSm: "640px",
  widthMd: "760px",
  widthLg: "880px",
  widthXl: "960px"
}, _t = {
  mobileMin: "320px",
  mobileMax: "560px",
  tabletMin: "561px",
  tabletMax: "1020px",
  desktopMin: "1021px"
}, Ue = {
  blue: "3px solid rgba(20, 119, 216, 0.75)",
  gray: "3px solid rgba(89, 89, 89, 0.75)",
  red: "3px solid rgba(210, 70, 54, 0.75)",
  green: "3px solid rgba(38, 137, 0, 0.76)"
}, a = {
  color: ot,
  fontFamily: Ee,
  fontWeight: Ie,
  schoolinks: je,
  spacing: Xe,
  border: Ye,
  modal: qe,
  breakpoint: _t,
  focusOutline: Ue
}, Ze = `@import './gtflexa.css';
@import './halisrounded.css';
/* 
* This file is auto-generated by running "yarn run build" (not "yarn run dev"). 
* Do not edit this file directly as changes will be overwritten.
* Add or update variables in src/utils/variables.js.
*/`, Ge = (t) => {
  const r = [];
  for (const o in t) {
    const e = Ne(o), c = t[o];
    for (const l in c) {
      const f = l.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase(), u = `--${e}-${f}`, x = c[l];
      r.push(`${u}: ${x};`);
    }
  }
  return `${Ze}
:root {
${r.map((o) => `  ${o}`).join(`
`)}
}
`;
}, va = () => {
  let t = !1;
  return {
    name: "generate-css-vars",
    apply: "build",
    config(r) {
      var o;
      (o = r.build) != null && o.watch && (t = !0);
    },
    buildStart() {
      if (t)
        return;
      console.log("Generating CSS variables...");
      const r = Ge(a), o = Ot.resolve("./src/utils/variables.css");
      Ot.writeFileSync(o, r, "utf-8"), console.log(`CSS variables written to ${o}`);
    }
  };
}, Je = {
  lead400: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  lead500: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  lead700: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  titleMd500: {
    fontSize: 16,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  titleMd700: {
    fontSize: 16,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  titleSm500: {
    fontSize: 14,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  titleSm700: {
    fontSize: 14,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodyMd400: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd500: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd600: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd700: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm400: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm500: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm600: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm700: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  meta400: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  meta700: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  label: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  tiny: {
    fontSize: 10,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "12px"
  },
  mono: {
    fontSize: 14,
    fontFamily: a.fontFamily.code,
    fontWeight: "bolder",
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "16px"
  },
  cursive: {
    fontSize: 16,
    fontFamily: a.fontFamily.signature,
    fontWeight: "bolder",
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "18px"
  },
  stat1: {
    fontSize: 40,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "46px"
  },
  stat2: {
    fontSize: 34,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "38px"
  },
  stat3: {
    fontSize: 30,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "34px"
  },
  stat4: {
    fontSize: 26,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "30px"
  },
  stat5: {
    fontSize: 22,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "26px"
  },
  stat6: {
    fontSize: 20,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "24px"
  },
  h1: {
    fontSize: 40,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "46px"
  },
  h2: {
    fontSize: 34,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "38px"
  },
  h3: {
    fontSize: 30,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "34px"
  },
  h4: {
    fontSize: 26,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "30px"
  },
  h5: {
    fontSize: 22,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "26px"
  },
  h6: {
    fontSize: 20,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  body1: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "19px"
  },
  body2: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  caption: {
    fontSize: 12,
    letterSpacing: "0",
    fontFamily: a.fontFamily.body,
    fontStyle: "normal",
    fontWeight: a.fontWeight.robotoMedium,
    lineHeight: "16px"
  },
  overline: {
    fontSize: 10,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    fontFamily: a.fontFamily.body,
    fontWeight: "bold",
    fontStyle: "normal",
    lineHeight: "16px"
  },
  subtitle1: {
    fontSize: 16,
    letterSpacing: "0.15px",
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  subtitle2: {
    fontSize: 14,
    letterSpacing: "0.1px",
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  button: {
    fontSize: 16,
    letterSpacing: "1.2px",
    fontFamily: a.fontFamily.base,
    textTransform: "none",
    fontStyle: "normal",
    fontWeight: a.fontWeight.halisBook,
    lineHeight: "16px"
  }
}, { color: k } = a, Qe = Zt({
  typography: Je,
  palette: {
    primary: {
      main: k.blue,
      light: k.blue,
      dark: k.blueDark,
      contrastText: k.white
    },
    secondary: {
      main: k.blue,
      light: k.blue,
      dark: k.blueDark,
      contrastText: k.white
    },
    action: {
      hover: k.blueExtraLight,
      selected: k.blueExtraLight
    },
    error: {
      main: "#d85446"
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      // mobile
      md: 561,
      // tablet
      lg: 1021,
      // desktop
      xl: 1600
    }
  },
  components: {
    // Customization
    /*
      Body font properties updated to v4 to prevent UI bugs.
      Related documentation.
      https://mui.com/guides/migration-v4/#cssbaseline
    */
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem",
          lineHeight: "1.43",
          letterSpacing: "0.01071em"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: "linear-gradient(0deg, rgba(2, 136, 209, 0.15), rgba(2, 136, 209, 0.15)), var(--color-white)"
        },
        icon: {
          marginRight: 4
        },
        deleteIcon: {
          marginLeft: 4
        },
        colorPrimary: {
          backgroundColor: k.blueExtraLight,
          color: k.font,
          "& > svg": {
            color: k.font
          }
        },
        deleteIconColorPrimary: {
          "&:hover": {
            color: k.font
          }
        },
        deletableColorPrimary: {
          "&:focus": {
            backgroundColor: k.blueDark
          }
        }
      }
    },
    // new overrides to counter breaking changes in mui v4
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          margin: "4px 0",
          color: k.grayDark,
          "&.Mui-disabled": { color: k.grayDark },
          "&.Mui-error": { color: "#d85446" }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard"
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: a.schoolinks.containerBorderRadius,
            "&.Mui-disabled": {
              backgroundColor: k.grayBg,
              "& fieldset": { borderColor: "#eee" }
            },
            "& fieldset": {
              borderColor: k.grayLight
            },
            "&:not(.Mui-disabled, .Mui-error):hover fieldset": {
              borderColor: k.blue
            },
            "&.Mui-error fieldset": {
              borderColor: k.red,
              borderWidth: "2px"
            },
            "& input::placeholder": {
              opacity: 1,
              color: k.gray
            }
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&.Mui-disabled": {
            "-webkit-text-fill-color": k.grayDark
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: "6px 12px"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingTop: 11,
          paddingBottom: 11
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          zIndex: 1400
          // has to be bigger than the MuiModal zIndex
        },
        option: {
          "&.Mui-focused": {
            backgroundColor: `${k.blueDark} !important`
          }
        }
      }
    },
    // existing overrides
    MuiModal: {
      styleOverrides: {
        root: {
          // lowered from 1350 to 1300 so we can see date pickers in modals
          zIndex: 1300
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        maxWidth: !1
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          zIndex: 1300
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            // underline color when textfield is inactive
            borderBottom: "2px solid #d8d8d8"
          },
          "&:after": {
            // underline color when textfield is active
            borderBottom: `2px solid ${k.blue}`
          },
          "&:hover:not($disabled):not($focused):not($error):before": {
            // underline color when hovered
            borderBottom: `2px solid ${k.blue}`
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
            // outline color when hovered
            borderColor: k.blue
          },
          "&$error $notchedOutline": {
            borderColor: k.red
          }
        },
        inputAdornedStart: {
          paddingLeft: 0
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&$focused": {
            color: `${k.grayDark} !important`
          },
          "&$error": {
            color: k.red
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          overflow: "inherit !important",
          "&.Mui-focused": {
            color: `${k.grayDark} !important`
          },
          "&.Mui-error": {
            color: `${k.grayDark} !important`
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&$selected": {
            backgroundColor: "rgba(2,136,209,0.05)"
          },
          "&$hover:hover": {
            backgroundColor: "rgba(2,136,209,0.05)"
          }
        }
      }
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (t) => t === "next" ? "Next Page" : t === "previous" ? "Previous Page" : ""
      },
      styleOverrides: {
        selectLabel: {
          margin: 0
        },
        displayedRows: {
          margin: 0
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#bbb !important",
          "&$active": {
            color: `${k.blue} !important`
          },
          "&$completed": {
            color: `${k.blue} !important`
          }
        },
        active: {},
        completed: {}
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: void 0
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "& > .textLink, & > .textLinkButton": {
            textDecoration: "underline"
          }
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiYearPicker: {
      styleOverrides: {
        root: {
          "& .PrivatePickersYear-yearButton": {
            fontFamily: "Roboto, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }
        }
      }
    },
    PrivatePickersYear: {
      styleOverrides: {
        yearButton: {
          fontFamily: "Roboto, sans-serif",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    }
  }
}), Ke = ({
  disableEmpty: t,
  number: r,
  color: o
}) => {
  const { color: e } = a;
  if (t && !r || o === "disabled")
    return e.grayLight;
  if (o === "font")
    return e.font;
  if (o === "orange")
    return e.orange;
  const c = `${Ae(o)}XtraDark`;
  return c in e ? e[c] : "";
}, Ve = ({
  hasWhiteBorder: t,
  isFilled: r,
  isOutlined: o,
  colorVar: e
}) => {
  const { border: c } = a;
  return t && r ? c.white : o ? `1px solid ${e}` : void 0;
}, Pe = ({
  isFilled: t,
  isOutlined: r,
  color: o,
  colorVar: e,
  number: c,
  disableEmpty: l
}) => {
  const { color: f } = a, u = !c && l, b = ["yellow", "orange", "disabled"].includes(o) || u;
  return t ? b ? f.font : f.white : r && b ? f.font : e;
}, It = ({
  label: t,
  style: r,
  classes: o,
  number: e = 0,
  color: c = "gray",
  size: l = "medium",
  variant: f = "filled",
  disableEmpty: u = !0,
  hasWhiteBorder: x = !1
}) => {
  const b = l === "large", y = f === "filled", M = f === "outlined", S = Ke({
    disableEmpty: u,
    number: e,
    color: c
  }), C = Ve({
    hasWhiteBorder: x,
    isFilled: y,
    isOutlined: M,
    colorVar: S
  }), w = Pe({
    isFilled: y,
    isOutlined: M,
    color: c,
    colorVar: S,
    number: e,
    disableEmpty: u
  });
  return /* @__PURE__ */ H("div", { style: r, className: T(ft.badgeContainer, o == null ? void 0 : o.root), children: [
    /* @__PURE__ */ n(
      "div",
      {
        "data-testid": "badgeNumberContainer",
        style: {
          backgroundColor: y ? S : "transparent",
          border: C
        },
        className: ft.badge,
        children: /* @__PURE__ */ n(
          "div",
          {
            "data-testid": "badgeNumber",
            className: T(ft.number, { [ft.large]: b }),
            style: {
              color: w
            },
            children: e
          }
        )
      }
    ),
    t ? /* @__PURE__ */ n(
      "div",
      {
        "data-testid": "badgeLabel",
        className: T(ft.label, { [ft.large]: b }),
        children: t
      }
    ) : null
  ] });
}, to = "_button_18nre_1", eo = "_loading_18nre_14", oo = "_withIconLeft_18nre_27", no = "_withLabel_18nre_27", ro = "_withIconRight_18nre_28", ao = "_blue_18nre_33", io = "_gray_18nre_37", lo = "_red_18nre_41", so = "_small_18nre_45", co = "_disabled_18nre_56", fo = "_badge_18nre_60", uo = "_compactButton_18nre_67", mo = "_compactSmall_18nre_86", go = "_compactSelect_18nre_90", ho = "_compactCircular_18nre_96", bo = "_shadowButton_18nre_101", po = "_green_18nre_132", yo = "_outlined_18nre_137", _o = "_text_18nre_138", xo = "_filled_18nre_198", vo = "_rightIcon_18nre_257", wo = "_large_18nre_261", So = "_icon_18nre_261", Mo = "_noLabel_18nre_262", ko = "_medium_18nre_267", $o = "_noLabelContainer_18nre_284", Co = "_label_18nre_288", Do = "_popoverRoot_18nre_307", Lo = "_popoverPaper_18nre_311", Wo = "_arrow_18nre_317", To = "_arrowTop_18nre_318", Fo = "_arrowBottom_18nre_319", p = {
  button: to,
  loading: eo,
  withIconLeft: oo,
  withLabel: no,
  withIconRight: ro,
  blue: ao,
  gray: io,
  red: lo,
  small: so,
  disabled: co,
  badge: fo,
  compactButton: uo,
  compactSmall: mo,
  compactSelect: go,
  compactCircular: ho,
  shadowButton: bo,
  green: po,
  outlined: yo,
  text: _o,
  filled: xo,
  rightIcon: vo,
  large: wo,
  icon: So,
  noLabel: Mo,
  medium: ko,
  noLabelContainer: $o,
  label: Co,
  popoverRoot: Do,
  popoverPaper: Lo,
  arrow: Wo,
  arrowTop: To,
  arrowBottom: Fo
}, Bo = ({
  badgeCount: t,
  bgColor: r,
  border: o,
  color: e,
  handleClick: c,
  hasIconLeft: l,
  hasIconRight: f,
  hasNoWrap: u,
  iconToRender: x,
  isFilled: b,
  isLoading: y,
  isOutlined: M,
  isSmall: S,
  isText: C,
  label: w,
  restButtonProps: h,
  showBadge: D,
  textColor: z,
  tooltipProps: E
}) => /* @__PURE__ */ n(gt, { title: (E == null ? void 0 : E.title) ?? "", ...E, children: /* @__PURE__ */ H(
  "button",
  {
    "data-testid": "base-button",
    ...h,
    className: T(h.className, p.button, {
      [p.small]: S,
      [p.disabled]: h.disabled,
      [p.text]: C,
      [p.loading]: y,
      [p.blue]: e === "blue",
      [p.red]: e === "red",
      [p.gray]: e === "gray",
      [p.withIconLeft]: l,
      [p.withIconRight]: f,
      [p.withLabel]: w
    }),
    style: {
      ...b || M ? {
        border: o
      } : { border: "none" },
      backgroundColor: r,
      color: z.var,
      whiteSpace: u ? "nowrap" : void 0,
      ...h.style
    },
    onClick: c,
    children: [
      (l || y) && x,
      w,
      f && x,
      D && /* @__PURE__ */ n(
        It,
        {
          number: t ?? 0,
          color: e,
          hasWhiteBorder: !0,
          classes: { root: p.badge }
        }
      )
    ]
  }
) }), Oo = ({
  badgeCount: t,
  bgColor: r,
  border: o,
  color: e,
  handleClick: c,
  hasNoWrap: l,
  iconToRender: f,
  innerLabel: u,
  isCompactSelect: x,
  isLoading: b,
  isSmall: y,
  label: M,
  restButtonProps: S,
  showBadge: C,
  textColor: w,
  textVariant: h,
  tooltipProps: D
}) => /* @__PURE__ */ n(gt, { title: (D == null ? void 0 : D.title) ?? "", ...D, children: /* @__PURE__ */ H(P, { flexDirection: "column", alignItems: "center", width: "fit-content", children: [
  /* @__PURE__ */ H(
    "button",
    {
      "data-testid": "compact-button",
      ...S,
      className: T(p.compactButton, S.className, {
        [p.compactCircular]: !y,
        [p.compactSmall]: y,
        [p.compactSelect]: x,
        [p.compactSmallSelect]: y && x,
        [p.disabled]: S.disabled,
        [p.loading]: b,
        [p.blue]: e === "blue",
        [p.red]: e === "red",
        [p.gray]: e === "gray"
      }),
      style: {
        backgroundColor: r,
        border: o,
        color: w.var,
        whiteSpace: l ? "nowrap" : void 0,
        ...S.style
      },
      onClick: c,
      children: [
        u && /* @__PURE__ */ n(ct, { variant: h, color: w.string, children: u }),
        f,
        x && /* @__PURE__ */ n(
          W,
          {
            icon: Kt,
            color: w.string
          }
        ),
        C && /* @__PURE__ */ n(
          It,
          {
            number: t ?? 0,
            color: e,
            hasWhiteBorder: !0,
            classes: { root: p.badge }
          }
        )
      ]
    }
  ),
  M && /* @__PURE__ */ n(ct, { color: `${e}XtraDark`, variant: "label", mt: 0.5, children: M.toUpperCase() })
] }) }), zo = ({ title: t }) => typeof t == "string" ? /* @__PURE__ */ n(xt, { children: t }) : t, Ro = "_tooltip_1hh81_3", Ho = {
  tooltip: Ro
}, gt = ({
  title: t = "",
  arrow: r = !0,
  tooltipClass: o = "",
  children: e,
  ...c
}) => {
  const { classes: l = {} } = c;
  return /* @__PURE__ */ n(
    Vt,
    {
      ...c,
      classes: {
        ...l,
        tooltip: T(Ho.tooltip, o)
      },
      title: t && /* @__PURE__ */ n(zo, { title: t }),
      enterTouchDelay: 0,
      arrow: r,
      children: e
    }
  );
}, No = {
  blue: p.blue,
  gray: p.gray,
  red: p.red,
  green: p.green
}, Ao = {
  outlined: p.outlined,
  filled: p.filled,
  text: p.text
}, Eo = {
  large: p.large,
  medium: p.medium,
  small: p.small
}, Io = ({
  classes: t,
  color: r = "blue",
  handleClick: o,
  hasIconRight: e,
  iconToRender: c,
  isLoading: l,
  label: f,
  restButtonProps: u,
  size: x = "large",
  tooltipProps: b,
  variant: y = "outlined"
}) => /* @__PURE__ */ n(gt, { title: (b == null ? void 0 : b.title) ?? "", ...b, children: /* @__PURE__ */ H(
  "button",
  {
    "data-testid": "shadow-button",
    ...u,
    className: T(
      p.shadowButton,
      No[r],
      Ao[y] || p.outlined,
      Eo[x],
      {
        [p.rightIcon]: e,
        [p.disabled]: u.disabled,
        [p.noLabelContainer]: !f,
        [p.loading]: l
      },
      u.className
    ),
    onClick: o,
    children: [
      c ? /* @__PURE__ */ n("span", { className: T(p.icon, { [p.noLabel]: !f }, t == null ? void 0 : t.icon), children: c }) : null,
      f ? /* @__PURE__ */ n("span", { className: T(p.label, t == null ? void 0 : t.label), children: f }) : null
    ]
  }
) }), jo = ({
  disabled: t,
  isLoading: r,
  confirmationOpenColor: o,
  color: e
}) => t && !r ? {
  string: "grayMedium",
  var: "var(--color-gray-medium)"
} : o ? {
  string: `${o}XtraDark`,
  var: `var(--color-${o}-xtra-dark)`
} : {
  string: `${e}XtraDark`,
  var: `var(--color-${e}-xtra-dark)`
}, Dt = ({
  badgeCount: t,
  children: r,
  classes: o,
  color: e = "blue",
  compactVariant: c,
  confirmationPopoverProps: l,
  hasIconLeft: f,
  hasIconRight: u,
  hasNoWrap: x,
  hasWhiteBackground: b,
  icon: y,
  innerLabel: M,
  isLoading: S,
  label: C,
  size: w = "medium",
  textVariant: h,
  tooltipProps: D,
  variant: z,
  withShadow: E,
  ...F
}) => {
  const [Y, I] = mt(null), q = ({
    currentTarget: X
  }) => I(X), J = (X) => {
    X && X.stopPropagation(), I(null);
  }, Q = !!Y, U = Q ? "popover" : void 0, B = c === "select", $ = c === "default", rt = w === "small", lt = z === "outlined", g = z === "filled", d = z === "text", m = !!t && Number.isInteger(t) && t > 0 && (lt || $), {
    confirmationOpenColor: s,
    confirmationButtonColor: v,
    confirmationText: _,
    confirmationPopover: L,
    confirmationButtonText: O,
    confirmationPopoverCancelButtonText: A,
    arrowDirection: N,
    arrow: Z,
    popoverPaperClassName: at
  } = l ?? {}, V = jo({
    disabled: F.disabled,
    isLoading: S,
    confirmationOpenColor: s,
    color: e
  }), nt = g ? V.var : b ? "white" : "transparent", j = {
    string: g ? "white" : V.string,
    var: g ? "var(--color-white)" : V.var
  }, tt = e === "gray" || F.disabled ? "1px solid var(--color-gray-medium)" : `1px solid var(--color-${e}-xtra-dark)`, it = {
    arrow: /* @__PURE__ */ n(
      W,
      {
        rotation: f ? 180 : void 0,
        icon: le
      }
    ),
    chevron: /* @__PURE__ */ n(
      W,
      {
        icon: u || f ? ce : se,
        rotation: f ? 180 : void 0
      }
    ),
    edit: /* @__PURE__ */ n(W, { "data-testid": "edit-icon", icon: re }),
    plus: /* @__PURE__ */ n(W, { icon: ae }),
    trash: /* @__PURE__ */ n(W, { icon: ie }),
    lock: /* @__PURE__ */ n(W, { icon: ne }),
    download: /* @__PURE__ */ n(W, { icon: ee })
  }, Tt = S ? /* @__PURE__ */ n(W, { "data-testid": "loader-icon", icon: oe, spin: !0 }) : Object.keys(it).includes(y) ? it[y] : y, Ft = (X) => {
    var bt;
    if (!(S || F.disabled)) {
      if (_ || L) {
        X.stopPropagation(), q(X);
        return;
      }
      (bt = F.onClick) == null || bt.call(F, X);
    }
  };
  return /* @__PURE__ */ H(xt, { children: [
    (() => {
      if (E)
        return /* @__PURE__ */ n(
          Io,
          {
            classes: o,
            color: e,
            handleClick: Ft,
            hasIconLeft: f,
            hasIconRight: u,
            iconToRender: Tt,
            isLoading: S,
            label: C,
            restButtonProps: F,
            size: w,
            tooltipProps: D,
            variant: z
          }
        );
      const X = {
        badgeCount: t,
        bgColor: nt,
        border: tt,
        color: e,
        handleClick: Ft,
        hasNoWrap: x,
        iconToRender: Tt,
        isLoading: S,
        isSmall: rt,
        label: C,
        showBadge: m,
        textColor: j,
        tooltipProps: D,
        restButtonProps: F
      };
      return B || $ ? /* @__PURE__ */ n(
        Oo,
        {
          isCompactSelect: B,
          innerLabel: M,
          textVariant: h,
          ...X
        }
      ) : /* @__PURE__ */ n(
        Bo,
        {
          hasIconLeft: f,
          hasIconRight: u,
          isText: d,
          isFilled: g,
          isOutlined: lt,
          ...X
        }
      );
    })(),
    /* @__PURE__ */ n(
      At,
      {
        id: U,
        open: Q,
        anchorEl: Y,
        onClose: J,
        anchorOrigin: {
          vertical: N === "top" ? "bottom" : "top",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: N === "top" ? "top" : "bottom",
          horizontal: "center"
        },
        classes: {
          root: p.popoverRoot,
          paper: T(p.popoverPaper, at, {
            [p.arrow]: Z,
            [p.arrowTop]: N === "top",
            [p.arrowBottom]: N === "bottom"
          })
        },
        ...l,
        children: L ? L({
          closePopover: () => I(null)
        }) : /* @__PURE__ */ H("div", { children: [
          _ && /* @__PURE__ */ n(ct, { variant: "bodySm400", mb: 1.5, children: _ }),
          /* @__PURE__ */ H(
            P,
            {
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              children: [
                /* @__PURE__ */ n(
                  Dt,
                  {
                    label: A ?? "Cancel",
                    size: "small",
                    color: "gray",
                    onClick: (X) => {
                      X.stopPropagation(), I(null);
                    }
                  }
                ),
                /* @__PURE__ */ n(
                  Dt,
                  {
                    label: O ?? "Delete",
                    size: "small",
                    variant: "outlined",
                    color: v ?? "red",
                    onClick: (X) => {
                      var bt;
                      X.stopPropagation(), (bt = F.onClick) == null || bt.call(F, X), I(null);
                    }
                  }
                )
              ]
            }
          )
        ] })
      }
    )
  ] });
};
function Xo(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Mt = { exports: {} }, Yo = Mt.exports, zt;
function qo() {
  return zt || (zt = 1, function(t, r) {
    (function(o, e) {
      t.exports = e();
    })(Yo, function() {
      var o = 1e3, e = 6e4, c = 36e5, l = "millisecond", f = "second", u = "minute", x = "hour", b = "day", y = "week", M = "month", S = "quarter", C = "year", w = "date", h = "Invalid Date", D = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, z = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, E = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(g) {
        var d = ["th", "st", "nd", "rd"], i = g % 100;
        return "[" + g + (d[(i - 20) % 10] || d[i] || d[0]) + "]";
      } }, F = function(g, d, i) {
        var m = String(g);
        return !m || m.length >= d ? g : "" + Array(d + 1 - m.length).join(i) + g;
      }, Y = { s: F, z: function(g) {
        var d = -g.utcOffset(), i = Math.abs(d), m = Math.floor(i / 60), s = i % 60;
        return (d <= 0 ? "+" : "-") + F(m, 2, "0") + ":" + F(s, 2, "0");
      }, m: function g(d, i) {
        if (d.date() < i.date()) return -g(i, d);
        var m = 12 * (i.year() - d.year()) + (i.month() - d.month()), s = d.clone().add(m, M), v = i - s < 0, _ = d.clone().add(m + (v ? -1 : 1), M);
        return +(-(m + (i - s) / (v ? s - _ : _ - s)) || 0);
      }, a: function(g) {
        return g < 0 ? Math.ceil(g) || 0 : Math.floor(g);
      }, p: function(g) {
        return { M, y: C, w: y, d: b, D: w, h: x, m: u, s: f, ms: l, Q: S }[g] || String(g || "").toLowerCase().replace(/s$/, "");
      }, u: function(g) {
        return g === void 0;
      } }, I = "en", q = {};
      q[I] = E;
      var J = "$isDayjsObject", Q = function(g) {
        return g instanceof rt || !(!g || !g[J]);
      }, U = function g(d, i, m) {
        var s;
        if (!d) return I;
        if (typeof d == "string") {
          var v = d.toLowerCase();
          q[v] && (s = v), i && (q[v] = i, s = v);
          var _ = d.split("-");
          if (!s && _.length > 1) return g(_[0]);
        } else {
          var L = d.name;
          q[L] = d, s = L;
        }
        return !m && s && (I = s), s || !m && I;
      }, B = function(g, d) {
        if (Q(g)) return g.clone();
        var i = typeof d == "object" ? d : {};
        return i.date = g, i.args = arguments, new rt(i);
      }, $ = Y;
      $.l = U, $.i = Q, $.w = function(g, d) {
        return B(g, { locale: d.$L, utc: d.$u, x: d.$x, $offset: d.$offset });
      };
      var rt = function() {
        function g(i) {
          this.$L = U(i.locale, null, !0), this.parse(i), this.$x = this.$x || i.x || {}, this[J] = !0;
        }
        var d = g.prototype;
        return d.parse = function(i) {
          this.$d = function(m) {
            var s = m.date, v = m.utc;
            if (s === null) return /* @__PURE__ */ new Date(NaN);
            if ($.u(s)) return /* @__PURE__ */ new Date();
            if (s instanceof Date) return new Date(s);
            if (typeof s == "string" && !/Z$/i.test(s)) {
              var _ = s.match(D);
              if (_) {
                var L = _[2] - 1 || 0, O = (_[7] || "0").substring(0, 3);
                return v ? new Date(Date.UTC(_[1], L, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, O)) : new Date(_[1], L, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, O);
              }
            }
            return new Date(s);
          }(i), this.init();
        }, d.init = function() {
          var i = this.$d;
          this.$y = i.getFullYear(), this.$M = i.getMonth(), this.$D = i.getDate(), this.$W = i.getDay(), this.$H = i.getHours(), this.$m = i.getMinutes(), this.$s = i.getSeconds(), this.$ms = i.getMilliseconds();
        }, d.$utils = function() {
          return $;
        }, d.isValid = function() {
          return this.$d.toString() !== h;
        }, d.isSame = function(i, m) {
          var s = B(i);
          return this.startOf(m) <= s && s <= this.endOf(m);
        }, d.isAfter = function(i, m) {
          return B(i) < this.startOf(m);
        }, d.isBefore = function(i, m) {
          return this.endOf(m) < B(i);
        }, d.$g = function(i, m, s) {
          return $.u(i) ? this[m] : this.set(s, i);
        }, d.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, d.valueOf = function() {
          return this.$d.getTime();
        }, d.startOf = function(i, m) {
          var s = this, v = !!$.u(m) || m, _ = $.p(i), L = function(nt, j) {
            var tt = $.w(s.$u ? Date.UTC(s.$y, j, nt) : new Date(s.$y, j, nt), s);
            return v ? tt : tt.endOf(b);
          }, O = function(nt, j) {
            return $.w(s.toDate()[nt].apply(s.toDate("s"), (v ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(j)), s);
          }, A = this.$W, N = this.$M, Z = this.$D, at = "set" + (this.$u ? "UTC" : "");
          switch (_) {
            case C:
              return v ? L(1, 0) : L(31, 11);
            case M:
              return v ? L(1, N) : L(0, N + 1);
            case y:
              var V = this.$locale().weekStart || 0, dt = (A < V ? A + 7 : A) - V;
              return L(v ? Z - dt : Z + (6 - dt), N);
            case b:
            case w:
              return O(at + "Hours", 0);
            case x:
              return O(at + "Minutes", 1);
            case u:
              return O(at + "Seconds", 2);
            case f:
              return O(at + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, d.endOf = function(i) {
          return this.startOf(i, !1);
        }, d.$set = function(i, m) {
          var s, v = $.p(i), _ = "set" + (this.$u ? "UTC" : ""), L = (s = {}, s[b] = _ + "Date", s[w] = _ + "Date", s[M] = _ + "Month", s[C] = _ + "FullYear", s[x] = _ + "Hours", s[u] = _ + "Minutes", s[f] = _ + "Seconds", s[l] = _ + "Milliseconds", s)[v], O = v === b ? this.$D + (m - this.$W) : m;
          if (v === M || v === C) {
            var A = this.clone().set(w, 1);
            A.$d[L](O), A.init(), this.$d = A.set(w, Math.min(this.$D, A.daysInMonth())).$d;
          } else L && this.$d[L](O);
          return this.init(), this;
        }, d.set = function(i, m) {
          return this.clone().$set(i, m);
        }, d.get = function(i) {
          return this[$.p(i)]();
        }, d.add = function(i, m) {
          var s, v = this;
          i = Number(i);
          var _ = $.p(m), L = function(N) {
            var Z = B(v);
            return $.w(Z.date(Z.date() + Math.round(N * i)), v);
          };
          if (_ === M) return this.set(M, this.$M + i);
          if (_ === C) return this.set(C, this.$y + i);
          if (_ === b) return L(1);
          if (_ === y) return L(7);
          var O = (s = {}, s[u] = e, s[x] = c, s[f] = o, s)[_] || 1, A = this.$d.getTime() + i * O;
          return $.w(A, this);
        }, d.subtract = function(i, m) {
          return this.add(-1 * i, m);
        }, d.format = function(i) {
          var m = this, s = this.$locale();
          if (!this.isValid()) return s.invalidDate || h;
          var v = i || "YYYY-MM-DDTHH:mm:ssZ", _ = $.z(this), L = this.$H, O = this.$m, A = this.$M, N = s.weekdays, Z = s.months, at = s.meridiem, V = function(j, tt, it, ht) {
            return j && (j[tt] || j(m, v)) || it[tt].slice(0, ht);
          }, dt = function(j) {
            return $.s(L % 12 || 12, j, "0");
          }, nt = at || function(j, tt, it) {
            var ht = j < 12 ? "AM" : "PM";
            return it ? ht.toLowerCase() : ht;
          };
          return v.replace(z, function(j, tt) {
            return tt || function(it) {
              switch (it) {
                case "YY":
                  return String(m.$y).slice(-2);
                case "YYYY":
                  return $.s(m.$y, 4, "0");
                case "M":
                  return A + 1;
                case "MM":
                  return $.s(A + 1, 2, "0");
                case "MMM":
                  return V(s.monthsShort, A, Z, 3);
                case "MMMM":
                  return V(Z, A);
                case "D":
                  return m.$D;
                case "DD":
                  return $.s(m.$D, 2, "0");
                case "d":
                  return String(m.$W);
                case "dd":
                  return V(s.weekdaysMin, m.$W, N, 2);
                case "ddd":
                  return V(s.weekdaysShort, m.$W, N, 3);
                case "dddd":
                  return N[m.$W];
                case "H":
                  return String(L);
                case "HH":
                  return $.s(L, 2, "0");
                case "h":
                  return dt(1);
                case "hh":
                  return dt(2);
                case "a":
                  return nt(L, O, !0);
                case "A":
                  return nt(L, O, !1);
                case "m":
                  return String(O);
                case "mm":
                  return $.s(O, 2, "0");
                case "s":
                  return String(m.$s);
                case "ss":
                  return $.s(m.$s, 2, "0");
                case "SSS":
                  return $.s(m.$ms, 3, "0");
                case "Z":
                  return _;
              }
              return null;
            }(j) || _.replace(":", "");
          });
        }, d.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, d.diff = function(i, m, s) {
          var v, _ = this, L = $.p(m), O = B(i), A = (O.utcOffset() - this.utcOffset()) * e, N = this - O, Z = function() {
            return $.m(_, O);
          };
          switch (L) {
            case C:
              v = Z() / 12;
              break;
            case M:
              v = Z();
              break;
            case S:
              v = Z() / 3;
              break;
            case y:
              v = (N - A) / 6048e5;
              break;
            case b:
              v = (N - A) / 864e5;
              break;
            case x:
              v = N / c;
              break;
            case u:
              v = N / e;
              break;
            case f:
              v = N / o;
              break;
            default:
              v = N;
          }
          return s ? v : $.a(v);
        }, d.daysInMonth = function() {
          return this.endOf(M).$D;
        }, d.$locale = function() {
          return q[this.$L];
        }, d.locale = function(i, m) {
          if (!i) return this.$L;
          var s = this.clone(), v = U(i, m, !0);
          return v && (s.$L = v), s;
        }, d.clone = function() {
          return $.w(this.$d, this);
        }, d.toDate = function() {
          return new Date(this.valueOf());
        }, d.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, d.toISOString = function() {
          return this.$d.toISOString();
        }, d.toString = function() {
          return this.$d.toUTCString();
        }, g;
      }(), lt = rt.prototype;
      return B.prototype = lt, [["$ms", l], ["$s", f], ["$m", u], ["$H", x], ["$W", b], ["$M", M], ["$y", C], ["$D", w]].forEach(function(g) {
        lt[g[1]] = function(d) {
          return this.$g(d, g[0], g[1]);
        };
      }), B.extend = function(g, d) {
        return g.$i || (g(d, rt, B), g.$i = !0), B;
      }, B.locale = U, B.isDayjs = Q, B.unix = function(g) {
        return B(1e3 * g);
      }, B.en = q[I], B.Ls = q, B.p = {}, B;
    });
  }(Mt)), Mt.exports;
}
var Uo = qo();
const st = /* @__PURE__ */ Xo(Uo), Zo = ({ event: t, children: r }) => /* @__PURE__ */ n(
  "div",
  {
    className: T("rbc-event-wrapper", t.color ?? "", {
      "rbc-event-filled": t.variant === "filled"
    }),
    children: r
  }
);
var Lt = /* @__PURE__ */ ((t) => (t.Back = "back", t.Forward = "forward", t))(Lt || {});
const Go = ({
  disabled: t,
  viewMode: r,
  viewLabel: o,
  onMove: e,
  onMoveToday: c,
  onChangeView: l
}) => /* @__PURE__ */ H(
  P,
  {
    className: "rbc-toolbar",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 0.5,
    children: [
      /* @__PURE__ */ n(P, { className: "rbc-left-toolbar", children: /* @__PURE__ */ n(
        "button",
        {
          className: "rbc-btn-standalone rbc-btn-today",
          type: "button",
          onClick: c,
          disabled: t,
          children: "Today"
        }
      ) }),
      /* @__PURE__ */ H(P, { gap: 0.5, alignItems: "center", children: [
        /* @__PURE__ */ n(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move back",
            disabled: t,
            onClick: () => {
              e(Lt.Back);
            },
            children: /* @__PURE__ */ n(W, { icon: Bt })
          }
        ),
        /* @__PURE__ */ n("h2", { className: "rbc-toolbar-label", children: o }),
        /* @__PURE__ */ n(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move forward",
            disabled: t,
            onClick: () => {
              e(Lt.Forward);
            },
            children: /* @__PURE__ */ n(W, { icon: Bt, rotation: 180 })
          }
        )
      ] }),
      /* @__PURE__ */ n("div", { className: "rbc-btn-group rbc-right-toolbar", children: ["Month", "Week", "Day"].map((u) => /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          disabled: t,
          onClick: () => {
            l(u.toLowerCase());
          },
          className: T({
            "rbc-active": r === u.toLowerCase()
          }),
          children: u
        },
        u
      )) })
    ]
  }
), Jo = {
  mobile: `(max-width: ${_t.mobileMax})`,
  tablet: `(min-width: ${_t.tabletMin}) and (max-width: ${_t.tabletMax})`,
  desktop: `(min-width: ${_t.desktopMin})`
}, Qo = (t = Jo) => {
  const r = $t(t.mobile), o = $t(t.tablet), e = $t(t.desktop);
  return { isMobile: r, isTablet: o, isDesktop: e };
}, P = ut.forwardRef(
  ({ children: t, className: r, ...o }, e) => /* @__PURE__ */ n(
    Pt,
    {
      "data-testid": "flexContainer",
      ref: e,
      className: r,
      display: "flex",
      ...o,
      children: t
    }
  )
), kt = (t, r) => t && t in a.color ? a.color[t] : r, W = ({
  className: t,
  color: r,
  onClick: o,
  fixedWidth: e = !1,
  inverse: c = !1,
  listItem: l = !1,
  spin: f = !1,
  swapOpacity: u = !1,
  "data-testid": x,
  ...b
}) => {
  const y = kt(r);
  return /* @__PURE__ */ n(
    ue,
    {
      className: t,
      color: y,
      "data-testid": x,
      fixedWidth: e,
      inverse: c,
      listItem: l,
      spin: f,
      swapOpacity: u,
      ...b
    }
  );
}, Wt = ({
  event: t,
  align: r = "start",
  tooltipPlacement: o
}) => {
  var b;
  const e = (t == null ? void 0 : t.variant) === "filled", c = t.icon ? t.icon : null, l = (b = t == null ? void 0 : t.start) == null ? void 0 : b.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  }), f = `${t.title}, ${l}`, u = /* @__PURE__ */ H("div", { className: "rbc-event-title", children: [
    t.title,
    ", ",
    l
  ] }), x = o ? /* @__PURE__ */ n(gt, { title: f, placement: o, children: u }) : u;
  return /* @__PURE__ */ H(P, { title: "", alignItems: r, gap: 0.5, "data-testid": t.title, children: [
    c ? /* @__PURE__ */ n(W, { icon: c, color: e ? "white" : t.color }) : null,
    /* @__PURE__ */ n("div", { className: "rbc-title-wrapper", children: x })
  ] });
}, Ko = ({ event: t, tooltipPlacement: r }) => /* @__PURE__ */ n(
  Wt,
  {
    align: "center",
    event: t,
    tooltipPlacement: r
  }
), Vo = ({
  initialDate: t,
  initialViewMode: r = "month",
  onRangeChange: o,
  onViewChange: e
}) => {
  const [c, l] = mt(t), [f, u] = mt(r), [x, b] = mt(r);
  r !== x && (b(r), u(r));
  const y = {
    day: "d",
    week: "w",
    month: "M"
  }, M = (h) => {
    u(h), S(c, y[h]), e == null || e(h);
  }, S = (h, D) => {
    const z = st(h).startOf(D).toDate(), E = st(h).endOf(D).toDate();
    o == null || o({ start: z, end: E });
  };
  return {
    currentDate: c,
    viewMode: f,
    onChangeView: M,
    onMove: (h) => {
      if (h === "back") {
        const z = st(c).subtract(1, y[f]).toDate();
        l(z), S(z, y[f]);
        return;
      }
      const D = st(c).add(1, y[f]).toDate();
      l(D), S(D, y[f]);
    },
    onMoveToday: () => {
      const h = st().toDate();
      l(h), S(h, "d");
    }
  };
};
function Po(t, r) {
  const o = st(r);
  switch (t) {
    case "week": {
      const e = o.clone().startOf("week"), c = o.clone().endOf("week");
      return `${e.format("MMMM DD")} - ${c.format(
        "DD, YYYY"
      )}`;
    }
    case "month":
      return o.format("MMMM, YYYY");
    case "day":
      return o.format("MMMM DD, YYYY");
    default:
      return "";
  }
}
const tn = de(st), wa = ({
  events: t,
  initialDate: r,
  initialViewMode: o = "month",
  height: e,
  selectable: c = !0,
  loading: l = !1,
  grow: f = !0,
  className: u,
  classes: x,
  onNavigate: b = () => {
  },
  onViewChange: y = () => {
  },
  onView: M = () => {
  },
  tooltipPlacement: S,
  onRangeChange: C,
  ...w
}) => {
  const { currentDate: h, viewMode: D, onChangeView: z, onMove: E, onMoveToday: F } = Vo({
    initialDate: r,
    initialViewMode: o,
    onRangeChange: C,
    onViewChange: y
  }), { containerClassName: Y = "", rootClassName: I = "" } = x ?? {}, q = Po(D, h), { isMobile: J } = Qo(), Q = J ? void 0 : S;
  return /* @__PURE__ */ H(
    "div",
    {
      className: T("rbc-calendar-container", Y, {
        grow: f,
        loading: l
      }),
      children: [
        /* @__PURE__ */ n(
          Go,
          {
            disabled: !!l,
            viewLabel: q,
            viewMode: D,
            onChangeView: z,
            onMoveToday: F,
            onMove: E
          }
        ),
        /* @__PURE__ */ n(
          fe,
          {
            className: T(I, {
              "rbc-week-view": D === "week"
            }),
            localizer: tn,
            date: h,
            events: t,
            startAccessor: "start",
            view: D,
            onView: M,
            toolbar: !1,
            selectable: c,
            onNavigate: b,
            components: {
              day: {
                event: (U) => /* @__PURE__ */ n(
                  Wt,
                  {
                    ...U,
                    tooltipPlacement: Q
                  }
                )
              },
              week: {
                event: (U) => /* @__PURE__ */ n(
                  Wt,
                  {
                    ...U,
                    tooltipPlacement: Q
                  }
                )
              },
              month: {
                event: (U) => /* @__PURE__ */ n(
                  Ko,
                  {
                    ...U,
                    tooltipPlacement: Q
                  }
                )
              },
              eventWrapper: Zo
            },
            endAccessor: "end",
            views: ["month", "week", "day"],
            style: { height: e },
            ...w
          }
        )
      ]
    }
  );
};
var R = /* @__PURE__ */ ((t) => (t.h1 = "h1", t.h2 = "h2", t.h3 = "h3", t.h4 = "h4", t.h5 = "h5", t.h6 = "h6", t.lead400 = "lead400", t.lead500 = "lead500", t.lead700 = "lead700", t.titleMd500 = "titleMd500", t.titleMd700 = "titleMd700", t.titleSm500 = "titleSm500", t.titleSm700 = "titleSm700", t.bodyMd400 = "bodyMd400", t.bodyMd500 = "bodyMd500", t.bodyMd600 = "bodyMd600", t.bodyMd700 = "bodyMd700", t.bodySm400 = "bodySm400", t.bodySm500 = "bodySm500", t.bodySm600 = "bodySm600", t.bodySm700 = "bodySm700", t.meta400 = "meta400", t.meta700 = "meta700", t.label = "label", t.tiny = "tiny", t.mono = "mono", t.cursive = "cursive", t.stat1 = "stat1", t.stat2 = "stat2", t.stat3 = "stat3", t.stat4 = "stat4", t.stat5 = "stat5", t.stat6 = "stat6", t))(R || {});
const Rt = {
  lead: R.lead400,
  leadBold: R.lead700,
  titleMd: R.titleMd500,
  titleMdBold: R.titleMd700,
  titleSm: R.titleSm500,
  titleSmBold: R.titleSm700,
  bodyMd: R.bodyMd400,
  bodyMdBold: R.bodyMd700,
  bodySm: R.bodySm400,
  bodySmBold: R.bodySm700,
  meta: R.meta400,
  metaBold: R.meta700,
  // Deprecated variants
  body1: R.bodyMd400,
  body2: R.bodySm400,
  subtitle1: R.titleMd500,
  subtitle2: R.titleSm500,
  caption: R.label,
  overline: R.tiny,
  button: R.bodyMd400
}, en = a.color.font, on = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/g, nn = (t = "") => {
  const r = a.color[t];
  return Object.keys(a.color).includes(t) || on.test(String(r)) ? r : (t && console.warn(`Wrong color name '${t}' provided, using fallback color.`), en);
}, rn = (t) => typeof t == "string" && document.createElement(t) instanceof HTMLUnknownElement ? "p" : t, an = (t) => {
  const r = Object.keys(Rt);
  return t in R ? t : r.includes(t) ? Rt[t] : R.bodyMd500;
}, ln = "_textWrapper_1bmn2_3", sn = "_italic_1bmn2_9", cn = "_bold_1bmn2_13", dn = "_rebrand_1bmn2_18", fn = "_underlined_1bmn2_22", pt = {
  textWrapper: ln,
  italic: sn,
  bold: cn,
  rebrand: dn,
  underlined: fn
}, ct = ut.forwardRef(
  ({
    className: t,
    color: r,
    component: o = "p",
    isBold: e,
    isItalic: c,
    isRebrand: l,
    isRebrandUnderlined: f,
    testId: u,
    variant: x = "bodyMd600",
    ...b
  }, y) => {
    const M = an(
      x
    );
    return /* @__PURE__ */ n(
      te,
      {
        ref: y,
        "data-testid": u,
        sx: { color: nn(r) },
        className: T(t, pt[M], {
          [pt.italic]: c,
          [pt.bold]: e,
          [pt.rebrand]: l,
          [pt.underlined]: f
        }),
        variant: M,
        component: rn(o),
        ...b
      }
    );
  }
), un = "_root_bokhp_1", mn = {
  root: un
}, Ht = {
  approved: {
    label: "REGISTERED",
    textColor: "greenContrastDark",
    backgroundColor: "greenExtraLight",
    icon: be,
    iconColor: "greenXtraDark"
  },
  requested: {
    label: "REQUEST PENDING",
    textColor: "orangeContrastDark",
    backgroundColor: "orangeExtraLight",
    icon: he,
    iconColor: "orangeXtraDark"
  },
  rejected: {
    label: "REQUEST DECLINED",
    textColor: "redContrastDark",
    backgroundColor: "redExtraLight",
    icon: ge,
    iconColor: "redXtraDark"
  },
  removed: {
    label: "UNREGISTERED",
    textColor: "font",
    backgroundColor: "grayExtraLight",
    icon: me,
    iconColor: "grayXtraDark"
  }
}, gn = ({ variant: t, label: r, icon: o }) => {
  if (!(t in Ht))
    return null;
  const {
    backgroundColor: e,
    label: c,
    icon: l,
    textColor: f,
    iconColor: u
  } = Ht[t];
  return /* @__PURE__ */ H(
    P,
    {
      alignItems: "center",
      className: mn.root,
      sx: {
        p: 1,
        backgroundColor: kt(e)
      },
      "data-testid": "card-cap",
      children: [
        /* @__PURE__ */ n(W, { icon: o || l, color: u, size: "xs" }),
        /* @__PURE__ */ n(ct, { ml: 0.5, variant: "tiny", color: f, children: r || c })
      ]
    }
  );
}, hn = (t) => /^http(s)?:\/\//.test(t) || /mailto:([^?]*)/.test(t), bn = "_root_154wt_1", pn = "_shadow_154wt_45", yn = "_rounded_154wt_49", Ct = {
  root: bn,
  shadow: pn,
  rounded: yn
}, _n = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "search",
  "section",
  "select",
  "slot",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
], xn = (t) => _n.includes(t), vn = (t) => t === void 0 ? "div" : typeof t == "string" ? xn(t) ? t : "div" : t === Et ? t : "div", wn = (t) => t === "a" || t === "button" || jt(t), jt = (t) => t === Et, Sa = ut.forwardRef(
  ({
    backgroundColor: t = "white",
    children: r,
    className: o = "",
    component: e = "div",
    href: c = "",
    onClick: l = () => null,
    shadow: f = !0,
    style: u = {},
    rounded: x = !0,
    width: b = "100%",
    newTab: y = !1,
    cardCapProps: M,
    "aria-label": S
  }, C) => {
    const w = c && (hn(c) || y), h = !!M, D = vn(e), z = wn(D), E = jt(D), F = h ? /* @__PURE__ */ H(P, { flexDirection: "column", children: [
      h && /* @__PURE__ */ n(gn, { ...M }),
      r
    ] }) : r, Y = {
      className: T(o, Ct.root, {
        [Ct.shadow]: f,
        [Ct.rounded]: x
      }),
      ref: C,
      style: {
        backgroundColor: kt(
          t,
          a.color.grayDark
        ),
        width: b,
        ...u
      },
      "data-testid": "card",
      "aria-label": S
    };
    return E ? ut.createElement(
      D,
      {
        ...Y,
        onClick: l,
        rel: w ? "noreferrer" : void 0,
        target: w ? "_blank" : void 0,
        to: c
      },
      F
    ) : ut.createElement(
      D,
      {
        ...Y,
        ...z ? {
          onClick: l,
          rel: w ? "noreferrer" : void 0,
          target: w ? "_blank" : void 0,
          href: c
        } : {}
      },
      F
    );
  }
), Sn = ({ tag: t }) => ["a", "button"].includes(t), Mn = "_buttonAdjustments_1vavw_5", kn = "_anchorAdjustments_1vavw_38", $n = "_pointer_1vavw_49", Cn = "_fullWidth_1vavw_53", vt = {
  buttonAdjustments: Mn,
  anchorAdjustments: kn,
  pointer: $n,
  fullWidth: Cn
}, Dn = Jt(
  ({
    tagName: t = "button",
    children: r,
    className: o,
    disabled: e,
    fullWidth: c,
    href: l,
    onClick: f = () => null,
    testId: u,
    ...x
  }, b) => {
    const y = (h) => {
      e || f(h);
    }, M = {
      ...x,
      ...t === "button" ? { type: "button" } : {}
    }, S = !e && l ? l : void 0, C = l ? "a" : "button", w = Sn({ tag: t }) ? t : C;
    return /* @__PURE__ */ n(
      w,
      {
        ref: b,
        className: T(o, {
          [vt.buttonAdjustments]: w === "button",
          [vt.anchorAdjustments]: w === "a",
          [vt.pointer]: !e,
          [vt.fullWidth]: c
        }),
        disabled: e,
        onClick: y,
        href: S,
        "data-testid": u,
        ...M,
        children: r
      }
    );
  }
), Ln = ({ size: t }) => t === "large" ? "bodySm400" : "meta400", Wn = ({ size: t, children: r }) => typeof r == "string" ? /* @__PURE__ */ n(ct, { variant: Ln({ size: t }), children: r }) : /* @__PURE__ */ n(xt, { children: r }), Tn = "_container_1upjo_1", Fn = "_largeContainer_1upjo_14", Bn = "_mediumContainer_1upjo_23", On = "_smallContainer_1upjo_32", zn = "_warningContainer_1upjo_41", Rn = "_tipContainer_1upjo_49", Hn = "_successContainer_1upjo_57", Nn = "_errorContainer_1upjo_65", An = "_pendingContainer_1upjo_73", En = "_infoContainer_1upjo_81", In = "_readOnlyContainer_1upjo_89", jn = "_clearIcon_1upjo_97", Xn = "_dismissIcon_1upjo_104", G = {
  container: Tn,
  largeContainer: Fn,
  mediumContainer: Bn,
  smallContainer: On,
  warningContainer: zn,
  tipContainer: Rn,
  successContainer: Hn,
  errorContainer: Nn,
  pendingContainer: An,
  infoContainer: En,
  readOnlyContainer: In,
  clearIcon: jn,
  dismissIcon: Xn
}, Nt = Object.freeze({
  tip: {
    className: G.tipContainer,
    icon: /* @__PURE__ */ n(W, { icon: ve })
  },
  warning: {
    className: G.warningContainer,
    icon: /* @__PURE__ */ n(W, { icon: Se })
  },
  success: {
    className: G.successContainer,
    icon: /* @__PURE__ */ n(W, { icon: pe })
  },
  error: {
    className: G.errorContainer,
    icon: /* @__PURE__ */ n(W, { icon: we })
  },
  pending: {
    className: G.pendingContainer,
    icon: /* @__PURE__ */ n(W, { icon: xe })
  },
  info: {
    className: G.infoContainer,
    icon: /* @__PURE__ */ n(W, { icon: ye })
  },
  readOnly: {
    className: G.readOnlyContainer,
    icon: /* @__PURE__ */ n(W, { icon: _e })
  }
}), Yn = Object.freeze({
  large: G.largeContainer,
  medium: G.mediumContainer,
  small: G.smallContainer
}), Ma = ({
  containerClass: t = "",
  children: r,
  variant: o = "tip",
  size: e = "medium",
  className: c = "",
  customIcon: l = null,
  onDismiss: f = void 0
}) => {
  const u = f !== void 0;
  return /* @__PURE__ */ H(
    P,
    {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      className: T(
        c,
        G.container,
        Nt[o].className,
        Yn[e],
        t
      ),
      children: [
        u ? /* @__PURE__ */ n("div", {}) : null,
        /* @__PURE__ */ H(P, { alignItems: "center", children: [
          l || Nt[o].icon,
          /* @__PURE__ */ n(Wn, { size: e, children: r })
        ] }),
        u ? /* @__PURE__ */ n(
          Dn,
          {
            testId: "dismissIcon",
            "aria-label": "Dismiss",
            onClick: f,
            className: G.dismissIcon,
            children: /* @__PURE__ */ n(W, { className: G.clearIcon, icon: Me })
          }
        ) : null
      ]
    }
  );
}, qn = "_loadingIcon_raaev_1", Un = "_loadingOverlay_raaev_10", Zn = "_coverParent_raaev_26", Gn = "_casefileVariant_raaev_33", wt = {
  loadingIcon: qn,
  loadingOverlay: Un,
  coverParent: Zn,
  casefileVariant: Gn
}, ka = ({
  className: t = "",
  iconColor: r,
  iconType: o = "line-scale",
  coverParent: e = !1,
  variant: c = "default",
  noFadeIn: l = !1,
  paperProps: f = {},
  ...u
}) => {
  const x = kt(r, a.color.grayDark);
  return /* @__PURE__ */ n(
    $e,
    {
      classes: {
        root: T(wt.loadingOverlay, t, e && wt.coverParent, {
          [wt.casefileVariant]: c === "casefile"
        })
      },
      "data-testid": "loading-overlay",
      ...f,
      children: /* @__PURE__ */ n(
        ke,
        {
          className: wt.loadingIcon,
          name: o,
          color: x,
          fadeIn: l ? "none" : "half",
          ...u
        }
      )
    }
  );
}, $a = ({ children: t }) => /* @__PURE__ */ n(Gt, { theme: Qe, children: t }), Jn = "_container_8swf9_1", Qn = "_dot_8swf9_12", Kn = "_red_8swf9_19", Vn = "_dotOutlined_8swf9_27", Pn = "_gray_8swf9_33", tr = "_orange_8swf9_47", er = "_green_8swf9_61", or = "_teal_8swf9_75", nr = "_blue_8swf9_89", rr = "_blueSteel_8swf9_103", ar = "_yellow_8swf9_117", ir = "_transparentBg_8swf9_132", yt = {
  container: Jn,
  dot: Qn,
  red: Kn,
  dotOutlined: Vn,
  gray: Pn,
  orange: tr,
  green: er,
  teal: or,
  blue: nr,
  blueSteel: rr,
  yellow: ar,
  transparentBg: ir
}, Ca = ({
  className: t = "",
  color: r = "green",
  "data-testid": o,
  dot: e = !1,
  dotVariant: c = "filled",
  label: l,
  variant: f = "filled"
}) => {
  const u = yt[r === "blue-steel" ? "blueSteel" : r];
  return /* @__PURE__ */ H(
    P,
    {
      alignItems: "center",
      className: T(yt.container, u, t, {
        [yt.transparentBg]: f === "transparent"
      }),
      "data-testid": o,
      children: [
        e && /* @__PURE__ */ n(
          "div",
          {
            "data-testid": "status-lozenge-dot",
            className: T(yt.dot, {
              [yt.dotOutlined]: c === "outlined"
            })
          }
        ),
        /* @__PURE__ */ n("span", { children: l })
      ]
    }
  );
}, lr = ({
  showPassword: t,
  setShowPassword: r
}) => /* @__PURE__ */ n(Le, { position: "end", children: /* @__PURE__ */ n(
  gt,
  {
    placement: "top",
    title: t ? "Hide Password" : "Show Password",
    children: /* @__PURE__ */ n(
      Dt,
      {
        onClick: () => r(!t),
        color: "gray",
        hasIconRight: !0,
        icon: t ? /* @__PURE__ */ n(W, { icon: We, color: "gray" }) : /* @__PURE__ */ n(W, { icon: Te, color: "gray" })
      }
    )
  }
) }), sr = "_root_qg8p0_1", cr = "_fullWidth_qg8p0_5", dr = "_outlinedInputRoot_qg8p0_9", fr = "_rootLoading_qg8p0_17", ur = "_rootWithStartAdornment_qg8p0_21", mr = "_label_qg8p0_25", gr = "_helperTextBox_qg8p0_29", hr = "_compactCharLimit_qg8p0_35", br = "_asterisk_qg8p0_46", pr = "_hideNumberArrows_qg8p0_50", et = {
  root: sr,
  fullWidth: cr,
  outlinedInputRoot: dr,
  rootLoading: fr,
  rootWithStartAdornment: ur,
  label: mr,
  helperTextBox: gr,
  compactCharLimit: hr,
  asterisk: br,
  hideNumberArrows: pr
}, Da = ut.forwardRef(
  ({
    // MUI TextField base props
    variant: t = "outlined",
    rows: r = 5,
    InputLabelProps: o,
    // InputProps/inputProps must be explicitly defined here to prevent styling conflicts with MUI's default props
    InputProps: e,
    inputProps: c,
    // Character limit related props
    charLimit: l,
    enableHardLimit: f,
    // prevent user to input more characters than charLimit
    compactCharLimit: u,
    // transform charLimit styles so that it does not affect the layout
    hideNumberArrows: x,
    // Styling props
    outlinedInputClasses: b,
    rootClass: y,
    // Testing props
    testId: M,
    "data-testid": S,
    // State props
    loading: C,
    // Rest of TextField props
    value: w,
    ...h
  }, D) => {
    const [z, E] = mt(!1), F = "helper-text", Y = (w == null ? void 0 : w.length) || 0, I = l && Y > l, q = f ? (w || "").slice(0, l) : w, J = C || !!(e != null && e.startAdornment), Q = (e == null ? void 0 : e.type) === "password", U = C ? /* @__PURE__ */ n(
      W,
      {
        "data-testid": "loader-icon",
        spin: !0,
        icon: Ce,
        color: "gray"
      }
    ) : e == null ? void 0 : e.startAdornment, B = Q ? /* @__PURE__ */ n(
      lr,
      {
        showPassword: z,
        setShowPassword: E
      }
    ) : e == null ? void 0 : e.endAdornment, $ = () => h.defaultValue ? { defaultValue: h.defaultValue } : {}, rt = {
      ...c,
      "data-testid": S || M,
      ...f && l ? { maxLength: l } : {},
      type: z ? "text" : e == null ? void 0 : e.type
    }, lt = T(et.root, y, {
      [et.rootWithStartAdornment]: J,
      [et.fullWidth]: h.fullWidth,
      [et.rootLoading]: C,
      [et.hideNumberArrows]: x && (e == null ? void 0 : e.type) === "number"
    }), g = () => !h.helperText && !l ? null : /* @__PURE__ */ H(xt, { children: [
      /* @__PURE__ */ n(ct, { variant: "label", id: F, children: h.helperText }),
      l && /* @__PURE__ */ H(ct, { variant: "label", children: [
        Y,
        "/",
        l
      ] })
    ] });
    return /* @__PURE__ */ n(
      De,
      {
        ...$(),
        "aria-describedby": h.helperText ? F : void 0,
        ref: D,
        rows: r,
        value: q,
        variant: t,
        disabled: C || h.disabled,
        error: !!(h.error || I),
        placeholder: C ? "loading" : h.placeholder,
        classes: {
          root: lt,
          ...h.classes
        },
        FormHelperTextProps: {
          classes: {
            root: T(et.helperTextBox, {
              [et.compactCharLimit]: u
            })
          }
        },
        InputLabelProps: {
          shrink: !0,
          classes: { root: et.label, asterisk: et.asterisk },
          ...o
        },
        InputProps: {
          ...e,
          startAdornment: U,
          endAdornment: B,
          classes: {
            ...b,
            root: T(et.outlinedInputRoot, b == null ? void 0 : b.root)
          }
        },
        inputProps: rt,
        helperText: g(),
        ...h
      }
    );
  }
), yr = "_paper_gwo6v_1", _r = "_popoverContainer_gwo6v_9", xr = "_arrow_gwo6v_14", vr = "_arrowBottom_gwo6v_25", wr = "_arrowTop_gwo6v_32", Sr = "_arrowLeft_gwo6v_39", Mr = "_arrowRight_gwo6v_46", kr = "_anchorButton_gwo6v_52", $r = "_bottom_gwo6v_58", Cr = "_top_gwo6v_59", Dr = "_left_gwo6v_63", Lr = "_right_gwo6v_64", Wr = "_noArrow_gwo6v_68", Tr = "_hoverable_gwo6v_73", Fr = "_disabled_gwo6v_74", K = {
  paper: yr,
  popoverContainer: _r,
  arrow: xr,
  arrowBottom: vr,
  arrowTop: wr,
  arrowLeft: Sr,
  arrowRight: Mr,
  anchorButton: kr,
  bottom: $r,
  top: Cr,
  left: Dr,
  right: Lr,
  noArrow: Wr,
  hoverable: Tr,
  disabled: Fr
}, La = ({
  anchorContent: t = () => /* @__PURE__ */ n("button", { type: "button", children: "Anchor" }),
  "aria-label": r,
  disabled: o = !1,
  disabledMessage: e = "Disabled",
  hideArrow: c = !1,
  hoverable: l = !1,
  messagePlacement: f = "top",
  onAnchorClick: u = () => null,
  onCloseCallback: x = () => null,
  paperClass: b,
  placement: y = "bottom",
  popoverContent: M = () => /* @__PURE__ */ n("div", {}),
  tooltipProps: S,
  ...C
}) => {
  const [w, h] = mt(null), D = Qt(null), z = {
    bottom: {
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
      transformOrigin: { vertical: "top", horizontal: "center" }
    },
    top: {
      anchorOrigin: { vertical: "top", horizontal: "center" },
      transformOrigin: { vertical: "bottom", horizontal: "center" }
    },
    left: {
      anchorOrigin: { vertical: "center", horizontal: "left" },
      transformOrigin: { vertical: "center", horizontal: "right" }
    },
    right: {
      anchorOrigin: { vertical: "center", horizontal: "right" },
      transformOrigin: { vertical: "center", horizontal: "left" }
    }
  }, E = (J) => {
    u(), h(w ? null : J.currentTarget);
  }, F = () => {
    h(null), x();
  }, Y = (J) => {
    l && h(J.currentTarget);
  }, I = () => {
    l && (h(null), x());
  };
  return /* @__PURE__ */ H(xt, { children: [
    /* @__PURE__ */ n(
      gt,
      {
        title: !o && !(S != null && S.title) ? "" : (S == null ? void 0 : S.title) || e,
        placement: f,
        ...S,
        children: /* @__PURE__ */ n(
          "button",
          {
            "aria-expanded": !!w,
            "aria-label": r,
            "aria-owns": l && w ? "mouse-over-popover" : void 0,
            "aria-haspopup": "true",
            disabled: o,
            type: "button",
            onClick: E,
            onMouseEnter: Y,
            onMouseLeave: I,
            className: T(K.anchorButton, K[y], {
              [K.hoverable]: l,
              [K.noArrow]: c,
              [K.disabled]: o
            }),
            children: t({ disabled: o })
          }
        )
      }
    ),
    /* @__PURE__ */ n(
      At,
      {
        sx: l ? { pointerEvents: "none" } : void 0,
        ...z[y],
        ...C,
        id: l ? "mouse-over-popover" : void 0,
        open: !!w,
        anchorEl: w,
        anchorReference: "anchorEl",
        onClose: F,
        disableRestoreFocus: l,
        disableEnforceFocus: l,
        classes: {
          paper: T(K.paper, b)
        },
        children: /* @__PURE__ */ H("div", { className: K.popoverContainer, children: [
          !c && /* @__PURE__ */ n(
            "span",
            {
              ref: D,
              className: T(K.arrow, {
                [K.arrowBottom]: y === "bottom",
                [K.arrowTop]: y === "top",
                [K.arrowLeft]: y === "left",
                [K.arrowRight]: y === "right"
              })
            }
          ),
          M({ setAnchor: h })
        ] })
      }
    )
  ] });
};
export {
  xa as Avatar,
  It as Badge,
  Dt as Button,
  wa as Calendar,
  Sa as Card,
  gn as CardCap,
  Dn as ClickableComponent,
  P as Flexbox,
  W as FontAwesomeIcon,
  Ma as InfoNote,
  ka as LoadingOverlay,
  $a as MuiThemeProvider,
  Ca as StatusLozenge,
  ct as Text,
  Da as TextInput,
  gt as Tooltip,
  La as WithPopover,
  Ae as camelCase,
  a as cssVars,
  va as generateCssVarsPlugin,
  Ne as kebabCase,
  Qe as theme,
  Qo as useMediaInfo
};
